module.exports = __webpack_public_path__ + "img/zfcg_18.d5cbec7c.png";